import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BankOutlinedSvg from "@ant-design/icons-svg/es/asn/BankOutlined";
import AntdIcon from "../components/AntdIcon";
var BankOutlined = function BankOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BankOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BankOutlined.displayName = 'BankOutlined';
}
export default /*#__PURE__*/React.forwardRef(BankOutlined);